import ScalarIconPackage_vue_vue_type_script_setup_true_lang_default from "./ScalarIconPackage.vue.script.js";
//#region src/components/ScalarIconPackage.vue
var ScalarIconPackage_default = ScalarIconPackage_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconPackage_default as default };

//# sourceMappingURL=ScalarIconPackage.js.map